// Pixel art icons from pixelarticons.com
// Using inline SVGs for reliability
import type React from "react"

export function MoneyIcon({ className = "", size = 24 }: { className?: string; size?: number }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="currentColor"
      className={className}
    >
      <path d="M5 2h14v2H5zM3 6V4h2v2zm0 12V6H1v12zm2 2v-2H3v2zm14 0H5v2h14zm2-2v2h-2v-2zm0-12h2v12h-2zm0 0V4h-2v2zM9 8h6v2h-2v6h-2v-6H9z" />
    </svg>
  )
}

export function HeartIcon({ className = "", size = 24 }: { className?: string; size?: number }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="currentColor"
      className={className}
    >
      <path d="M9 2H5v2H3v2H1v6h2v2h2v2h2v2h2v2h2v2h2v-2h2v-2h2v-2h2v-2h2v-2h2V6h-2V4h-2V2h-4v2h-2v2h-2V4H9z" />
    </svg>
  )
}

export function MoodSadIcon({ className = "", size = 24 }: { className?: string; size?: number }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="currentColor"
      className={className}
    >
      <path d="M5 2h14v2H5zM3 6V4h2v2zm0 12V6H1v12zm2 2v-2H3v2zm14 0H5v2h14zm2-2v2h-2v-2zm0-12h2v12h-2zm0 0V4h-2v2zM7 8h2v4H7zm8 0h2v4h-2zm-6 8v-2h2v-2h2v2h2v2z" />
    </svg>
  )
}

export function TrophyIcon({ className = "", size = 24 }: { className?: string; size?: number }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="currentColor"
      className={className}
    >
      <path d="M7 2h10v2h4v8h-4v2h-2v2h-2v4h4v2H7v-2h4v-4H9v-2H7v-2H3V4h4zm0 8h2V4H5v6zm10 0h2V4h-2v6z" />
    </svg>
  )
}

export function SkullIcon({ className = "", size = 24 }: { className?: string; size?: number }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="currentColor"
      className={className}
    >
      <path d="M7 2h10v2h2v2h2v8h-2v4h-2v2h-2v-4h-2v4h-2v-4H9v4H7v-2H5v-4H3V6h2V4h2zm2 10h2V8H7v4zm6 0h2V8h-2v4z" />
    </svg>
  )
}

export function PauseIcon({ className = "", size = 24 }: { className?: string; size?: number }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="currentColor"
      className={className}
    >
      <path d="M10 4H5v16h5zm9 0h-5v16h5z" />
    </svg>
  )
}

export function PlayIcon({ className = "", size = 24 }: { className?: string; size?: number }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="black"
      className={className}
    >
      <path d="M10 20H8V4h2v2h2v2h2v2h2v4h-2v2h-2v2h-2v2z" />
    </svg>
  )
}

export function CloseIcon({ className = "", size = 24 }: { className?: string; size?: number }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="currentColor"
      className={className}
    >
      <path d="M5 5h2v2H5zm4 4H7V7h2zm2 2H9V9h2zm2 0h-2v2H9v2H7v2H5v2h2v-2h2v-2h2v-2h2v2h2v2h2v2h2v-2h-2v-2h-2v-2h-2zm2-2v2h-2V9zm2-2v2h-2V7zm0 0V5h2v2z" />
    </svg>
  )
}

export function CheckIcon({ className = "", size = 24 }: { className?: string; size?: number }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="currentColor"
      className={className}
    >
      <path d="M18 6h2v2h-2zm-2 4V8h2v2zm-2 2v-2h2v2zm-2 2h2v-2h-2zm-2 2h2v-2h-2zm-2 0v2h2v-2zm-2-2h2v2H6zm0 0H4v-2h2z" />
    </svg>
  )
}

export function ChevronRightIcon({ className = "", size = 24 }: { className?: string; size?: number }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="currentColor"
      className={className}
    >
      <path d="M10 6h2v2h-2zm0 2v2H8v2H6v2h2v2h2v2h2v-2h2v-2h2v-2h-2V8h-2V6h-2z" />
    </svg>
  )
}

export function ChevronLeftIcon({ className = "", size = 24 }: { className?: string; size?: number }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="currentColor"
      className={className}
    >
      <path d="M14 6h-2v2h2zm0 2v2h2v2h2v2h-2v2h-2v2h-2v-2H8v-2H6v-2h2V8h2V6h2z" />
    </svg>
  )
}

export function RedoIcon({ className = "", size = 24 }: { className?: string; size?: number }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="currentColor"
      className={className}
    >
      <path d="M4 10h2v2h2v2H6v2H4v2h2v-2h2v-2h2v-2h4V8h-2V6h-2V4h6v2h2v2h2v4h-2v2h-2v2h-2v2H8v-2H6v-2H4z" />
    </svg>
  )
}

export function LoginIcon({ className = "", size = 24 }: { className?: string; size?: number }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="currentColor"
      className={className}
    >
      <path d="M5 3H3v18h2v-2h2v-2h2v-2h2v-2H3v-2h6V9H7V7H5V5h14v14h-7v2h9V3zm8 8h8v2h-8z" />
    </svg>
  )
}

export function LogoutIcon({ className = "", size = 24 }: { className?: string; size?: number }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="currentColor"
      className={className}
    >
      <path d="M5 3h16v4h-2V5H5v14h14v-2h2v4H3V3zm12 4h2v2h2v2h2v2h-2v2h-2v2h-2v-2h-2v-2H7v-2h8V9h2z" />
    </svg>
  )
}

export function LockIcon({ className = "", size = 24 }: { className?: string; size?: number }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="currentColor"
      className={className}
    >
      <path d="M15 2H9v2H7v4H4v14h16V8h-3V4h-2zm-4 8h6v10H7V10h4zm2-6v4H9V4h2v2z" />
    </svg>
  )
}

export function TrashIcon({ className = "", size = 24 }: { className?: string; size?: number }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="currentColor"
      className={className}
    >
      <path d="M16 2v4h6v2h-2v14H4V8H2V6h6V2zm-2 2h-4v2h4zm0 4H6v12h12V8z" />
    </svg>
  )
}

export function ChartIcon({ className = "", size = 24 }: { className?: string; size?: number }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="currentColor"
      className={className}
    >
      <path d="M5 2h14v20H5zm2 2v16h10V4zm4 6h4v8H9v-2h2z" />
    </svg>
  )
}

export function SwordsIcon({ className = "", size = 24 }: { className?: string; size?: number }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="currentColor"
      className={className}
    >
      <path d="M2 2h6v2H6v2H4v2h2v2h2v2h2V8h2V6h2V4h2V2h6v6h-2v2h-2v2h-2v2h2v2h2v2h-2v2h-2v-2h-2v-2h-2v2H8v2H6v-2h2v-2h2v-2H8v-2H6v-2H4v-2H2z" />
    </svg>
  )
}

export function UsersIcon({ className = "", size = 24 }: { className?: string; size?: number }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="currentColor"
      className={className}
    >
      <path d="M2 4h6v6H2zm2 2v2h2V6zm10-2h6v6h-6zm2 2v2h2V6zM4 12h4v2H4zm0 2H2v6h8v-4H6v2H4zm12 0v-2h4v2h-2v4h2v2h-8v-6z" />
    </svg>
  )
}

export function MenuIcon({ className = "", size = 24 }: { className?: string; size?: number }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="currentColor"
      className={className}
    >
      <path d="M4 6h16v2H4V6zm0 5h16v2H4v-2zm16 5H4v2h16v-2z" />
    </svg>
  )
}

export function WalletIcon({ className = "", size = 24 }: { className?: string; size?: number }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="currentColor"
      className={className}
    >
      <path d="M18 3H2v18h18v-4h2V7h-2V3h-2zm0 14v2H4V5h14v2h-8v10h8zm2-2h-8V9h8v6zm-4-4h-2v2h2v-2z" />
    </svg>
  )
}

export function VolumeIcon({ className = "", size = 24 }: { className?: string; size?: number }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={size} height={size} fill="currentColor" className={className}>
      <path d="M11 2h2v20h-2v-2H9v-2h2V6H9V4h2V2zM7 8V6h2v2H7zm0 8H3V8h4v2H5v4h2v2zm0 0v2h2v-2H7zm10-6h-2v4h2v-4zm2-2h2v8h-2V8zm0 8v2h-4v-2h4zm0-10v2h-4V6h4z" />
    </svg>
  )
}

export function VolumeMutedIcon({ className = "", size = 24 }: { className?: string; size?: number }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={size} height={size} fill="currentColor" className={className}>
      <path d="M13 2h-2v2H9v2H7v2H3v8h4v2h2v2h2v2h2V2zM9 18v-2H7v-2H5v-4h2V8h2V6h2v12H9zm10-6.777h-2v-2h-2v2h2v2h-2v2h2v-2h2v2h2v-2h-2v-2zm0 0h2v-2h-2v2z" />
    </svg>
  )
}

export function MusicIcon({ className = "", size = 24 }: { className?: string; size?: number }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={size} height={size} fill="currentColor" className={className}>
      <path d="M8 4h12v16h-8v-8h6V8h-8v12H2v-8h6V4zm0 10H4v4h4v-4zm10 0h-4v4h4v-4z" />
    </svg>
  )
}

export function LoaderIcon({ className = "", size = 24, style }: { className?: string; size?: number; style?: React.CSSProperties }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="currentColor"
      className={`animate-spin ${className}`}
      style={style}
    >
      <path d="M13 2h-2v6h2zm0 14h-2v6h2zm9-5v2h-6v-2zM8 11v2H2v-2zm9-6h2v2h-2zm2 0V3h-2v2h-2v2h2v2h2V7h2V5zm-9 9H8v2H6v2h2v2h2v-2h2v-2h-2zm7 3h2v2h-2zm2 0v-2h2v2zm-2 2v2h2v-2zM6 4H4v2h2zm0 2v2H4v2H2V8h2V4h2z" />
    </svg>
  )
}
